import React from "react";

function Customers(){
return(
<>
{/* <!-- About Section  -->*/}
	<div className="process-area bg-cover section-padding">
        <div className="container">
            <div className="row">
                <div className="offset-lg-2 col-lg-8 text-center">
                    <div className="section-title">
                        <p>Courier Services Work Frequently World Wide</p>
                        <h2>How We <b>Work</b> for <b>Customers</b></h2>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-lg-3 col-md-6 col-sm-12 wow fadeInUp animated" data-wow-delay="100ms">
                    <div className="single-process-area text-center">                        
                        <div className="process-icon">
                            <img src="assets/img/icon/process/web-Photoroom.png" alt=""/>
                        </div>
                        <h4>Apply Online</h4>
                        <p>You can apply with details in online for our services.</p>                        
                        <span className="count-big">01</span>
                    </div>
                </div>
                <div className="col-lg-3 col-md-6 col-sm-12 wow fadeInUp animated" data-wow-delay="200ms">
                    <div className="single-process-area text-center">                        
                        <div className="process-icon">
                            <img src="assets/img/icon/process/document-Photoroom.png" alt=""/>
                        </div>
                        <h4>Documentation</h4>
                        <p>Our experts check docs on submission as per policy.</p>
                        <span className="count-big">02</span>
                    </div>
                </div>
                <div className="col-lg-3 col-md-6 col-sm-12 wow fadeInUp animated" data-wow-delay="300ms">
                    <div className="single-process-area text-center">                        
                        <div className="process-icon">
                            <img src="assets/img/icon/process/call-center-Photoroom.png" alt=""/>
                        </div>
                        <h4>Processing</h4>
                        <p>After reviewing your documents we will get in touch.</p>
                        <span className="count-big">03</span>
                    </div>
                </div>
                <div className="col-lg-3 col-md-6 col-sm-12 wow fadeInUp animated" data-wow-delay="400ms">
                    <div className="single-process-area text-center">                      
                        <div className="process-icon">
                            <img src="assets/img/icon/process/package-Photoroom.png" alt=""/>
                        </div>
                        <h4>Final Destination</h4>
                        <p>You are all ready to deliver or supply your package.</p>
                        <span className="count-big">04</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</>

)


}    
export default Customers;